import { Project, ProjectDto } from 'types/schema.type';

export const buildProject = (projectDto: ProjectDto): Project => {
    return {
        ...projectDto,
    };
};

